import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@medme/ui"
import { cn } from "@medme/ui/lib"
import { ChevronDown } from "lucide-react"

import { useSelectedBusiness } from "../hooks/use-selected-business"

type BusinessSelectorProps = {
	className?: string
}

export function BusinessSelector({ className }: BusinessSelectorProps) {
	const {
		businesses,
		selectedBusinessId,
		selectedBusinessName,
		setSelectedBusinessId,
	} = useSelectedBusiness()

	if (businesses.length <= 1) {
		return null
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				type="button"
				className={cn(
					"inline-flex items-center gap-2 rounded-md border border-mm-border bg-mm-card px-3.5 py-2 text-sm text-mm-foreground shadow-xs outline-none hover:bg-mm-muted-2 focus-visible:border-mm-border-strong focus-visible:ring-[3px] focus-visible:ring-black/5",
					className,
				)}
			>
				{selectedBusinessName}
				<ChevronDown
					size={15}
					strokeWidth={2}
					className="text-mm-muted-fg"
					aria-hidden
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="start"
				className="border-mm-border bg-mm-card"
			>
				{businesses.map((business) => (
					<DropdownMenuItem
						key={business.internalID}
						className={cn(
							"cursor-pointer text-mm-foreground focus:bg-mm-muted-2",
							selectedBusinessId === business.internalID && "font-semibold",
						)}
						onSelect={() => setSelectedBusinessId(business.internalID)}
					>
						{business.name}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
